(function () {
const $67ea77d20fec5145$var$initialized = new Set();
function $67ea77d20fec5145$var$initAuthorBio() {
    const toggles = document.querySelectorAll(".toggle-author-bio");
    toggles.forEach((toggle)=>{
        if (!$67ea77d20fec5145$var$initialized.has(toggle)) {
            const authorBio = toggle.parentElement.querySelector(".author-bio");
            const close = authorBio.querySelector(".close-author-bio");
            toggle.addEventListener("click", ()=>$67ea77d20fec5145$var$toggleBio(authorBio));
            close.addEventListener("click", ()=>$67ea77d20fec5145$var$closeBio(authorBio));
            $67ea77d20fec5145$var$initialized.add(toggle);
        }
    });
}
function $67ea77d20fec5145$var$toggleBio(authorBio) {
    if (authorBio instanceof HTMLDivElement) {
        authorBio.classList.toggle("author-bio-open");
        document.addEventListener("click", outsideCloseBio);
    }
    function outsideCloseBio(event) {
        if (authorBio instanceof HTMLDivElement) {
            const toggle = event.target.closest(".toggle-author-bio");
            if (!authorBio.contains(event.target) && toggle === null) {
                $67ea77d20fec5145$var$closeBio(authorBio);
                document.removeEventListener("click", outsideCloseBio);
            }
        }
    }
}
function $67ea77d20fec5145$var$closeBio(authorBio) {
    authorBio.classList.remove("author-bio-open");
}
document.addEventListener("DOMContentLoaded", $67ea77d20fec5145$var$initAuthorBio);
document.addEventListener("content-added", $67ea77d20fec5145$var$initAuthorBio);

})();
//# sourceMappingURL=author-bio.js.map
